import { render, staticRenderFns } from "./CmgNutritionCalculatorPrimaryBanner.vue?vue&type=template&id=539d8190&scoped=true&lang=pug&"
import script from "./cmg-nutrition-calculator-primary-banner.ts?vue&type=script&lang=ts&"
export * from "./cmg-nutrition-calculator-primary-banner.ts?vue&type=script&lang=ts&"
import style0 from "./CmgNutritionCalculatorPrimaryBanner.vue?vue&type=style&index=0&id=539d8190&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539d8190",
  null
  
)

export default component.exports